import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VsolvConfigService } from './services/config.service';

@NgModule({
  imports: [CommonModule],
  providers: [VsolvConfigService],
})
export class ConfigWebModule {}
